import * as R from 'ramda';

export default function DocumentManagementController(
  documentManagementDialog,
  ssDialogService,
  loaderService
) {
  const vm = this;

  vm.parentFolderId = -1;
  vm.canAttach = vm.attachCallback && R.type(vm.attachCallback) === 'Function';

  vm.handleDocumentManagementDialogClick = _handleDocumentManagementDialogClick;

  function _handleDocumentManagementDialogClick($event) {
    if (vm.onOpenCallBack === undefined || vm.onOpenCallBack === null || vm.onOpenCallBack()) {
      loaderService.showViewLoader = true;
      /*
      docDataService.getItemList(
        vm.serviceId,
        vm.parentFolderId,
        vm.attachmentTypeId,
        vm.attachmentEntityId
      ).then((res) => {
        vm.folderList = res.data.result;
        R.forEach(
          (folder) => {
            folder.isExpanded = false;
          },
          vm.folderList
        );
        loaderService.showViewLoader = false;
        */
      ssDialogService.dialogs.global.documentManagementDialog = ssDialogService.alert(
        documentManagementDialog.getOptions($event, {
          serviceId: vm.serviceId,
          parentFolderId: vm.parentFolderId,
          dialogTitle: vm.dialogTitle,
          canAddFolder: vm.canAddFolder,
          canDeleteFolder: vm.canDeleteFolder,
          canAddDocument: vm.canAddDocument,
          canDeleteDocument: vm.canDeleteDocument,
          canAttach: vm.canAttach,
          attachCallback: vm.attachCallback,
          maxAttachments: vm.maxAttachments,
          attachedIds: vm.attachedIds,
          attachmentTypeId: vm.attachmentTypeId,
          attachmentEntityId: vm.attachmentEntityId,
          folderList: vm.folderList,
          customerServices: vm.customerServices,
          onCloseCallBack: vm.onCloseCallBack,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.global.documentManagementDialog);
      /* }); */
    }
  }
}

DocumentManagementController.$inject = [
  'documentManagementDialog',
  'ssDialogService',
  'loaderService',
];
